import PriorityIssue from "./PriorityIssue";
import PriorityTask from "./PriorityTask";

const PriorityTab = () => {
  return (
    <div className=" row">
      <div className="col-lg-6">
        <PriorityTask />
      </div>
      <div className="col-lg-6">
        <PriorityIssue />
      </div>
    </div>
  );
};
export default PriorityTab;
